import React, { useEffect } from 'react'

import { BackToProjects } from '../../../../components/'
import Images from '../../../../constants/Images'

import './Project4.css'

const Project4 = () => {
  useEffect(() => {
    document.title = "Randy | Project 4";  
  }, []);

  return (
    <div className='project4_content'>
        <img src={Images.ProjectHSoon} alt="Project image header" />
        <div className='project4_content-summary'>
          <h2>Project 4</h2>
          <p>Jan 2020 - Mar 2020</p>
        </div>
        <BackToProjects />
    </div>
  )
}

export default Project4